// removed by extract-text-webpack-plugin
module.exports = {"notification":"Notification-hashed__notification__1CR6j","notification_open":"Notification-hashed__notification_open__2OQ5f","notification__displacededstuff":"Notification-hashed__notification__displacededstuff__39JsX"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileNotification/Notification-hashed.scss
// module id = 662
// module chunks = 0